import EventEmitter from 'eventemitter3';
export const PageLifecycleStates = {
    ACTIVE: 'active',
    PASSIVE: 'passive',
    HIDDEN: 'hidden',
    FROZEN: 'frozen',
    TERMINATED: 'terminated',
    DISCARDED: 'discarded',
};
export class PageLifecycleWatcher extends EventEmitter {
    #wasInitialized = false;
    #state;
    get state() {
        return this.#state;
    }
    get wasInitialized() {
        return this.#wasInitialized;
    }
    init() {
        if (this.#wasInitialized) {
            return;
        }
        this.#wasInitialized = true;
        this.#state = this.#getState();
        const opts = { capture: true };
        const onStateChange = () => this.#transitionTo(this.#getState());
        ['pageshow', 'focus', 'blur', 'visibilitychange', 'resume'].forEach((type) => {
            window.addEventListener(type, onStateChange, opts);
        });
        window.addEventListener('freeze', () => {
            this.#transitionTo(PageLifecycleStates.FROZEN);
        }, opts);
        window.addEventListener('pagehide', (event) => {
            this.#transitionTo(event.persisted
                ? PageLifecycleStates.FROZEN
                : PageLifecycleStates.TERMINATED);
        });
    }
    #transitionTo(nextState) {
        const prevState = this.#state;
        if (nextState !== prevState) {
            this.#state = nextState;
            this.emit('change', this.#state);
        }
    }
    #getState() {
        if (document.visibilityState === 'hidden') {
            return PageLifecycleStates.HIDDEN;
        }
        if (document.hasFocus()) {
            return PageLifecycleStates.ACTIVE;
        }
        return PageLifecycleStates.PASSIVE;
    }
}
export const pageLifeCycleWatcher = new PageLifecycleWatcher();
